import React from 'react'
import { Ordering } from 'storfox-filter'

import { WAREHOUSE_COLUMNS as tableColumns } from './WarehouseTable'

import { WAREHOUSE_FILTER_NAME as name } from '../../constants'

export const warehouseOrderingOptions = {
  name,
  tableColumns
}

function WarehouseOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default WarehouseOrderingForm
